import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $f7router = _ref.$f7router,
      $on = _ref.$on,
      $update = _ref.$update;

  /*
   * Se esite un token utente reindirizza e delega alla pagina dei servizi
   * il controllo dello stato utente
   */
  $on('pageBeforeIn', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var mytoken, urlParams, username, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return myApp.server.authToken();

          case 2:
            mytoken = _context.sent;

            if (!mytoken) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", $f7router.navigate('/services/', {
              animate: false,
              clearPreviousHistory: true
            }));

          case 5:
            if ($f7.device.cordova) {
              _context.next = 34;
              break;
            }

            urlParams = new URLSearchParams(location.href);

            if (!urlParams.has('authId')) {
              _context.next = 33;
              break;
            }

            // user autenticato
            username = atob(urlParams.get('authId'));
            $f7.preloader.show();
            _context.prev = 10;
            _context.next = 13;
            return myApp.server.post('auth/phone', {
              usr: username,
              pwd: Date.now()
            });

          case 13:
            res = _context.sent;

            if (!res.ok) {
              _context.next = 22;
              break;
            }

            _context.next = 17;
            return myApp.server.authToken(username);

          case 17:
            _context.next = 19;
            return myApp.server.getQrcode();

          case 19:
            // apre la pagina di servizio
            $f7router.navigate('/services/', {
              animate: false,
              clearPreviousHistory: true
            });
            _context.next = 23;
            break;

          case 22:
            // errore generato dal server
            console.log('Server status: ' + res.status);

          case 23:
            _context.next = 28;
            break;

          case 25:
            _context.prev = 25;
            _context.t0 = _context["catch"](10);
            // errore nell'accesso al server
            $f7.alertError(_context.t0);

          case 28:
            _context.prev = 28;
            $f7.preloader.hide();
            return _context.finish(28);

          case 31:
            _context.next = 34;
            break;

          case 33:
            console.log('Errore nel recupero del parametro authId. Operazione annullata');

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[10, 25, 28, 31]]);
  })));

  var changeLanguage = function changeLanguage(ev) {
    var selectedLanguage = $(ev.target).data('lang');
    lng = language[selectedLanguage];
    localStorage.language = selectedLanguage;
    myApp.languageChanged = true;
    $update();
  };

  var openPopup = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ev) {
      var file_exists, l, file, html, res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file_exists = ['en', 'it', 'fr', 'ed', 'de'];
              l = file_exists.find(function (item) {
                return item == lng.key;
              }) || file_exists[0];
              file = 'static/html/' + $(ev.target).data('text') + '_' + l + '.html';

              if (!$f7.device.cordova) {
                _context2.next = 9;
                break;
              }

              _context2.next = 6;
              return myApp.server.readFile(file);

            case 6:
              html = _context2.sent;
              _context2.next = 15;
              break;

            case 9:
              _context2.next = 11;
              return fetch(file);

            case 11:
              res = _context2.sent;
              _context2.next = 14;
              return res.text();

            case 14:
              html = _context2.sent;

            case 15:
              $('#popup-privacy-link').attr('href', DOCUMENTS_ADDRESS + $(ev.target).data('text') + '_' + l + '.pdf');
              $('.popup-privacy').find('.content').html(html);
              $f7.popup.open('.popup-privacy');

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function openPopup(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var iAgree = function iAgree(ev) {
    var ok = $('#privacy').prop('checked') && $('#terma_and_conditions').prop('checked') && $('#adv').prop('checked');
    ok ? $('#btnNext').removeClass('invisible') : $('#btnNext').addClass('invisible');
  };

  var login = function login() {
    myApp.signIn = false;
    $update();
    $f7.loginScreen.open('#my-login-screen');
  };

  var signin = function signin() {
    myApp.signIn = true;
    $update();
    $f7.loginScreen.open('#my-login-screen');
  };

  var signinPhone = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var debug, username, res, o, token, myinterval;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // ------------- debug -------------
              debug = false;

              if (!(!$f7.device.cordova && window.location.hostname === 'localhost' && debug)) {
                _context4.next = 22;
                break;
              }

              console.log('DEBUG', location.href);
              username = '+393201493368';
              _context4.next = 6;
              return myApp.server.post('auth/phone', {
                usr: username,
                pwd: Date.now()
              });

            case 6:
              res = _context4.sent;

              if (!res.ok) {
                _context4.next = 20;
                break;
              }

              _context4.next = 10;
              return res.json();

            case 10:
              o = _context4.sent;
              console.log(o); // salva token di accesso

              _context4.next = 14;
              return myApp.server.authToken(username);

            case 14:
              token = _context4.sent;
              console.log('Token: ' + token); // richiede e salva qrcode

              _context4.next = 18;
              return myApp.server.getQrcode();

            case 18:
              // apre la pagina di servizio
              $f7router.navigate('/services/', {
                animate: false,
                clearPreviousHistory: true
              });
              return _context4.abrupt("return");

            case 20:
              _context4.next = 24;
              break;

            case 22:
              if ($f7.device.cordova) {
                _context4.next = 24;
                break;
              }

              return _context4.abrupt("return", location.href = 'https://dreamgest.com/auth/it/doctorpet/?ref=' + encodeURIComponent(location.href.replace(/\?.+/, '')));

            case 24:
              // ------------- /webapp -------------
              myApp.iabLoadUrl = null;
              myApp.iab('https://dreamgest.com/auth/it/doctorpass');
              myinterval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var urlParams, _username, _res;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!myApp.iabLoadUrl) {
                          _context3.next = 31;
                          break;
                        }

                        urlParams = new URLSearchParams(myApp.iabLoadUrl);
                        myApp.iabLoadUrl = false;

                        if (!urlParams.has('authId')) {
                          _context3.next = 29;
                          break;
                        }

                        // user autenticato
                        _username = atob(urlParams.get('authId'));
                        $f7.preloader.show();
                        _context3.prev = 6;
                        _context3.next = 9;
                        return myApp.server.post('auth/phone', {
                          usr: _username,
                          pwd: Date.now()
                        });

                      case 9:
                        _res = _context3.sent;

                        if (!_res.ok) {
                          _context3.next = 18;
                          break;
                        }

                        _context3.next = 13;
                        return myApp.server.authToken(_username);

                      case 13:
                        _context3.next = 15;
                        return myApp.server.getQrcode();

                      case 15:
                        // apre la pagina di servizio
                        $f7router.navigate('/services/', {
                          animate: false,
                          clearPreviousHistory: true
                        });
                        _context3.next = 19;
                        break;

                      case 18:
                        // errore generato dal server
                        console.log('Server status: ' + _res.status);

                      case 19:
                        _context3.next = 24;
                        break;

                      case 21:
                        _context3.prev = 21;
                        _context3.t0 = _context3["catch"](6);
                        // errore nell'accesso al server
                        $f7.alertError(_context3.t0);

                      case 24:
                        _context3.prev = 24;
                        $f7.preloader.hide();
                        return _context3.finish(24);

                      case 27:
                        _context3.next = 30;
                        break;

                      case 29:
                        console.log('Errore nel recupero del parametro authId. Operazione annullata');

                      case 30:
                        clearInterval(myinterval);

                      case 31:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[6, 21, 24, 27]]);
              })), 500);

            case 27:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function signinPhone() {
      return _ref4.apply(this, arguments);
    };
  }();

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="home">
    <div class="page-content bg-color-white hide-navbar-on-scroll display-flex flex-direction-column align-items-center justify-content-center unselectable">
      <img width="250" src="static/logo.png" alt=""/>
      <h1>${lng.welcome}!</h1>
      <p class='margin-horizontal text-align-center'>${lng.welcome_2}</p>

      <div class="block row">
        <div class="col text-align-center">
          <img src="static/flags/en.png" width="100%" style="max-width: 55px" @click=${changeLanguage} data-lang="en" alt=""/>
          ${lng.key === 'en' ? $h`
          <div class="highlight-bar"></div>
          `:''}
        </div>
        <div class="col text-align-center">
          <img src="static/flags/it.png" width="100%" style="max-width: 55px" @click=${changeLanguage} data-lang="it" alt=""/>
          ${lng.key === 'it' ? $h`
          <div class="highlight-bar"></div>
          `:''}
        </div>
        <div class="col text-align-center">
          <img src="static/flags/fr.png" width="100%" style="max-width: 55px" @click=${changeLanguage} data-lang="fr" alt=""/>
          ${lng.key === 'fr' ? $h`
          <div class="highlight-bar"></div>
          `:''}
        </div>
        <div class="col text-align-center">
          <img src="static/flags/de.png" width="100%" style="max-width: 55px" @click=${changeLanguage} data-lang="de" alt=""/>
          ${lng.key === 'de' ? $h`
          <div class="highlight-bar"></div>
          `:''}
        </div>
        <div class="col text-align-center">
          <img src="static/flags/es.png" width="100%" style="max-width: 55px" @click=${changeLanguage} data-lang="es" alt=""/>
          ${lng.key === 'es' ? $h`
          <div class="highlight-bar"></div>
          `:''}
        </div>
      </div>

      <div class="text-align-center" style="width: 100vw; max-width: 380px;">
        <div  class="text-align-left margin-top text-color-gray text-bold margin-left">${lng.i_agree}:</div>
        <table style="width: calc(100% - 30px)" class="margin-top-half margin-horizontal">
          <tr>
            <td class="text-align-left">
              <a href="#" class="link text-color-blue" @click=${openPopup} data-text="privacy">${lng.privacy_policy}<br/></a>
            </td>
            <td>
              <label class="toggle">
                <input type="checkbox" @change=${iAgree} id="privacy" name="privacy"/>
                <span class="toggle-icon"></span>
              </label>
            </td>
          </tr>
          <tr>
            <td class="text-align-left">
              <a href="#" class="link text-color-blue" @click=${openPopup} data-text="terms_and_conditions">${lng.terms_and_conditions} <br/></a>
            </td>
            <td>
              <label class="toggle">
                <input type="checkbox" @change=${iAgree} id="terma_and_conditions" name="privacy"/>
                <span class="toggle-icon"></span>
              </label>
            </td>
          </tr>
          <tr>
            <td class="text-align-left">
              <a href="#" class="link text-color-blue" @click=${openPopup} data-text="receive_adv">${lng.receive_adv}</a>
            </td>
            <td>
              <label class="toggle">
                <input type="checkbox" @change=${iAgree} id="adv" name="privacy"/>
                <span class="toggle-icon"></span>
              </label>
            </td>
          </tr>
        </table>

        <div id="btnNext" class='margin text-align-center invisible'>
          <button class='button button-large button-round button-outline button-block' style="margin: auto" @click=${signinPhone}>
            <span class="padding-horizontal">${lng.next}</span>
            <i class='icon f7-icons'>arrow_right</i>
          </button>
        </div>

      </div>
    </div>

    <div class="popup popup-privacy popup-tablet-fullscreen unselectable">
      <a id="popup-privacy-link" href="#" class="text-color-blue margin float-left external" target="_system" download>
        <i class="f7-icons">square_arrow_up</i>
      </a>
      <a href="#" class="link text-color-blue popup-close margin float-right">${lng.close} <i class="f7-icons right">xmark</i></a>
      <div class="content popup-lg-content"></div>
    </div>

  </div>
`
    }
    ;
});